export default __webpack_public_path__ + "static/media/echo128.7b8ae2d9.png";